var _mask, _path, _path2, _path3, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 105,
    viewBox: "0 0 107 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2530_24",
    maskUnits: "userSpaceOnUse",
    x: -0.448242,
    y: 0,
    width: 76,
    height: 77,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.448242,
    width: 76,
    height: 77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8018 14C50.2111 14 39.956 17.7147 31.8222 24.4973C23.6885 31.2799 18.1914 40.7005 16.2883 51.1188L60.8018 59.25V14Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8018 14C50.2111 14 39.956 17.7147 31.8222 24.4973C23.6885 31.2799 18.1914 40.7005 16.2883 51.1188L60.8018 59.25V14Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8018 14C50.2111 14 39.956 17.7147 31.8222 24.4973C23.6885 31.2799 18.1914 40.7005 16.2883 51.1188L60.8018 59.25V14Z",
    stroke: "#00CAA1",
    strokeWidth: 28,
    mask: "url(#path-1-outside-1_2530_24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5518 59.25C15.5518 34.2591 35.8109 14 60.8018 14H102.571C104.493 14 106.052 15.5584 106.052 17.4808V59.25C106.052 84.2409 85.7926 104.5 60.8018 104.5C35.8109 104.5 15.5518 84.2409 15.5518 59.25Z",
    fill: "#CCE6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2530_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 36,
    width: 47,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.8018,
    y: 36,
    width: 46,
    height: 46,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2530_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9681 78.1666L72.3014 70.5H53.1348C52.0806 70.5 51.1782 70.1246 50.4275 69.3739C49.6768 68.6232 49.3014 67.7208 49.3014 66.6666V64.75H70.3848C71.4389 64.75 72.3414 64.3746 73.0921 63.6239C73.8428 62.8732 74.2181 61.9708 74.2181 60.9166V47.5H76.1348C77.1889 47.5 78.0914 47.8753 78.8421 48.626C79.5928 49.3767 79.9681 50.2791 79.9681 51.3333V78.1666ZM45.4681 59.3354L47.7202 57.0833H66.5514V43.6666H45.4681V59.3354ZM41.6348 68.5833V43.6666C41.6348 42.6125 42.0101 41.71 42.7608 40.9594C43.5115 40.2087 44.4139 39.8333 45.4681 39.8333H66.5514C67.6056 39.8333 68.508 40.2087 69.2587 40.9594C70.0094 41.71 70.3848 42.6125 70.3848 43.6666V57.0833C70.3848 58.1375 70.0094 59.0399 69.2587 59.7906C68.508 60.5413 67.6056 60.9166 66.5514 60.9166H49.3014L41.6348 68.5833Z",
    fill: "#1072D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1771b8e1cb253953d5dfd6dd84b5dedb.svg";
export { ForwardRef as ReactComponent };